module.exports = __webpack_public_path__ + "img/logo.aadf816d.png";